import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { BrandPanel } from '../components/organisms/brand-panel/brand-panel';
import { ThemeToggle } from '../components/atoms/theme-toggle/theme-toggle';

const Container = styled.main`
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.bgPage};

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  }
`;

const Right = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 32px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 32px 20px 48px;
  }
`;

const ToggleSlot = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
`;

export const AuthLayout = () => (
  <Container>
    <BrandPanel />
    <Right>
      <ToggleSlot>
        <ThemeToggle />
      </ToggleSlot>
      <Outlet />
    </Right>
  </Container>
);
